import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import { Box, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import IntegrationChip from "./IntegrationChip";

const IntegrationFilter = ({ integrations, onChipClick, filterTools }) => {
  const [expanded, setExpanded] = useState(true);
  const [selectedIntegration, setSelectedIntegration] = useState("");
  useEffect(() => {
    const tools = filterTools;
    if (tools) {
      for (const [key, value] of Object.entries(tools)) {
        if (value === true) {
          setSelectedIntegration(key);
        }
      }
    }
  }, [filterTools]);
  return (
    <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap={2}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: 1,
          overflow: "hidden",
          width: "100%",
          maxHeight: expanded ? "none" : 40,
        }}
      >
        {integrations.map((integration, index) => (
          <IntegrationChip
            key={index}
            name={integration}
            selected={selectedIntegration === integration}
            onChipClick={(name) => {
              onChipClick(name);
              setSelectedIntegration(name);
            }}
            cancelSelected={false}
          />
        ))}
      </Box>
      <IconButton
        onClick={() => setExpanded(!expanded)}
        sx={{ display: "block", marginLeft: "auto", marginTop: 1 }}
      >
        {expanded ? (
          <KeyboardArrowUpRoundedIcon />
        ) : (
          <KeyboardArrowDownRoundedIcon />
        )}
      </IconButton>
    </Box>
  );
};

export default IntegrationFilter;
